import React, { FC, memo, useRef } from "react";

import StartDestination from "Components/StartDestination";
import { areEqualShallow } from "Utils/areEqual";

interface Props {
  showDirections: boolean;
  suggestions: any[];
  startingPoint: any;
  destination: any;
  setStartingPoint: (val: any) => void;
  setDestination: (val: any) => void;
  setShowDirections: (setShowDirections: boolean) => void;
  instructions: string[];
}
const StartDestinationContainer: FC<Props> = memo(
  ({
    showDirections,
    suggestions,
    startingPoint,
    destination,
    setStartingPoint,
    setDestination,
    setShowDirections,
    instructions,
  }: Props) => {
    const swapPoints = () => {
      setStartingPoint(destination);
      setDestination(startingPoint);
    };
    const directionsRef = useRef(null);

    return (
      <StartDestination
        showDirections={showDirections}
        setShowDirections={setShowDirections}
        suggestions={suggestions}
        startingPoint={startingPoint}
        destination={destination}
        setStartingPoint={setStartingPoint}
        setDestination={setDestination}
        swap={swapPoints}
        instructions={instructions}
        directionsRef={directionsRef}
      />
    );
  },
  areEqualShallow
);

export default StartDestinationContainer;
try {
    // @ts-ignore
    StartDestination.displayName = "StartDestination";
    // @ts-ignore
    StartDestination.__docgenInfo = { "description": "", "displayName": "StartDestination", "props": { "showDirections": { "defaultValue": null, "description": "", "name": "showDirections", "required": true, "type": { "name": "boolean" } }, "suggestions": { "defaultValue": null, "description": "", "name": "suggestions", "required": true, "type": { "name": "any[]" } }, "startingPoint": { "defaultValue": null, "description": "", "name": "startingPoint", "required": true, "type": { "name": "any" } }, "destination": { "defaultValue": null, "description": "", "name": "destination", "required": true, "type": { "name": "any" } }, "setStartingPoint": { "defaultValue": null, "description": "", "name": "setStartingPoint", "required": true, "type": { "name": "(val: any) => void" } }, "setDestination": { "defaultValue": null, "description": "", "name": "setDestination", "required": true, "type": { "name": "(val: any) => void" } }, "setShowDirections": { "defaultValue": null, "description": "", "name": "setShowDirections", "required": true, "type": { "name": "(setShowDirections: boolean) => void" } }, "instructions": { "defaultValue": null, "description": "", "name": "instructions", "required": true, "type": { "name": "string[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/StartDestination/StartDestination.tsx#StartDestination"] = { docgenInfo: StartDestination.__docgenInfo, name: "StartDestination", path: "src/shared/containers/StartDestination/StartDestination.tsx#StartDestination" };
}
catch (__react_docgen_typescript_loader_error) { }